<script lang="ts">
	import type { ISbStoryData } from '@storyblok/js';
	import { editable } from '../editable';
	import type { SbImage, SbValueProp } from '../types';
	import Blok from '../blok.svelte';
	import Image from '../components/image.svelte';
	import PageGrid16 from '../components/pageGrid16.svelte';
	import type { ButtonV3Props } from './buttonV3.svelte';

	interface Props {
		content: ISbStoryData<{
			headline: string;
			subheadline: string;
			cta: Array<ISbStoryData<ButtonV3Props>['content']>;
			asset?: SbImage;
			asset_desktop?: SbImage;
			value_props: Array<ISbStoryData<SbValueProp>>;
		}>['content'];
	}

	let { content }: Props = $props();
</script>

<section use:editable={content} class="w-full bg-white px-3 py-[10px] text-brown-1 lg:p-5">
	<div class="w-full overflow-hidden rounded-[20px] bg-brown-6 pt-10 lg:aspect-video lg:pt-20">
		<PageGrid16>
			<div class="col-span-full px-6 lg:px-20">
				<h1
					class="text-center text-[36px]/[112%] font-semibold tracking-[-.36px] lg:text-[64px]/[110%] lg:tracking-[-.64px]"
				>
					{content.headline}
				</h1>
				{#if content.subheadline && content.subheadline.length > 0}
					<h2
						class="mt-3 text-balance text-center text-[16px]/[150%] tracking-[-.16px] lg:mt-4 lg:text-[20px]/[140%] lg:tracking-[-.2px]"
					>
						{content.subheadline}
					</h2>
				{/if}
				<div class="mb-9 mt-7 flex justify-center gap-6 lg:my-10">
					{#each content.value_props as prop}
						<Blok content={prop} />
					{/each}
				</div>
				{#each content.cta as cta}
					<Blok content={cta} />
				{/each}
			</div>
			{#if content.asset}
				<Image
					wrapperClass="lg:hidden w-full col-span-full"
					class="aspect-3/2 w-full"
					src={content.asset.filename}
					alt={content.asset.alt}
					title={content.asset.title}
					width={860}
				/>
			{/if}
			{#if content.asset_desktop}
				<Image
					wrapperClass="max-lg:hidden w-full col-start-3 col-end-[15] xl:col-start-2 xl:col-end-[16] 2xl:col-span-full"
					class="mt-5"
					src={content.asset_desktop.filename}
					alt={content.asset_desktop.alt}
					title={content.asset_desktop.title}
				/>
			{/if}
		</PageGrid16>
	</div>
</section>
